
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/mapping-data",
      function () {
        return require("private-next-pages/syncs/mapping-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/mapping-data"])
      });
    }
  